export default "__VITE_ASSET__D26Phwce__"